const { BRAND } = process.env.ENV_VALUES

require(`./src/${BRAND}/theme.scss`)

export const content = require(`./src/${BRAND}/content.js`)
